import AdjustmentDetails from './AdjustmentDetails';

export default AdjustmentDetails;
